export default {
  star: 'Favorite',
  playAgain: {
    name: 'Replay Setting',
    radioTitle: 'Can Replay',
    inputTitle: 'Replay times',
    options: ['No', 'Yes'],
    unit: 'Times',
    unlimited: 'Unlimited times',
  },
  autoEndTime: {
    name: 'Operation Time Limit',
    radioTitle: 'Time limit',
    inputTitle: 'Time',
    options: ['Unlimited', 'Limited'],
  },
  global_click: {
    name: 'Fullscreen redirection available',
    desc: 'Redirect to landing page when users click anywhere on the screen',
  },
  auto_click: {
    name: 'Auto Redirection',
    desc: 'Redirect to landing page automatically after default time countdown',
  },
  yd_click: {
    name: 'Incentive Redirection',
    desc: 'Non-CTA redirections other than global redirection and auto redirection',
  },
  colorConfig: {
    name: 'Color Config',
  },
  difficulty: {
    configured: 'Edit',
    configure: 'Edit',
    easy: {
      name: 'Easy',
    },
    medium: {
      name: 'Medium',
    },
    hard: {
      name: 'Hard',
    },
  },
  stars: {
    name: 'Favorite',
  },
  level: {
    name: 'Level Setting',
  },
  score: {
    name: 'Scoring Setting',
  },
  jump: {
    name: 'Redirect Setting',
  },
  time: {
    name: 'Time Setting',
  },
  rate: {
    name: 'Frequency Setting',
  },
  range: {
    name: 'Range Setting',
  },
  prob: {
    name: 'Probability setting',
  },
}
